// Used with SSO + passcodes
import { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } from '../session-storage';

const pendingPasscodeKey = (eventUuid: string): string => `registration.passcode.${eventUuid}`;

export const setPendingPasscode = (eventUuid: string | null | undefined, passcode: string): void => {
	if (!eventUuid) return;

	if (!passcode) {
		removeSessionStorageItem(pendingPasscodeKey(eventUuid));
		return;
	}

	setSessionStorageItem(pendingPasscodeKey(eventUuid), passcode, 0.5);
};

export const getPendingPasscode = (eventUuid: string | null | undefined): string | undefined => {
	if (!eventUuid) return undefined;

	const passcode = getSessionStorageItem(pendingPasscodeKey(eventUuid));

	return typeof passcode === 'string' && passcode ? passcode : undefined;
};
